import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const BannerContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1918mpo3"
})(_ref => {
  let {
    theme
  } = _ref;
  return {
    backgroundColor: '#FFC814',
    padding: '10px 20px',
    zIndex: 100,
    color: '#000000',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    display: 'flex',
    margin: '0 auto',
    width: '100%',
    '& .banner-message': {
      display: 'flex',
      flexWrap: 'no-wrap',
      alignItems: 'center',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      color: theme.customColors.purple[500]
    },
    '& .banner-actions': {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      zIndex: 100
    }
  };
}, "");
const ActionButton = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1918mpo2"
})(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    border: "1px solid ".concat(theme.customColors.purple[500]),
    borderRadius: '20px',
    cursor: 'pointer',
    padding: '4px 24px',
    marginRight: '10px',
    transition: 'all 0.3s',
    color: theme.customColors.purple[500],
    '&:hover': {
      backgroundColor: theme.customColors.purple[500],
      color: '#ffffff',
      border: "1px solid ".concat(theme.customColors.purple[500])
    }
  };
}, "");
const IconWrapper = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1918mpo1"
})(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    color: theme.customColors.purple[500],
    cursor: 'pointer'
  };
}, "");
const DialogWrapper = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1918mpo0"
})(() => ({
  padding: '48px 48px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '.dialog-title': {
    fontSize: '18px',
    fontWeight: 700,
    marginBottom: '12px'
  },
  '.dialog-message': {
    color: '#5C5C5C',
    textAlign: 'center',
    marginBottom: '15px'
  },
  '.dialog-actions': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '20px',
    width: '100%',
    '.dialog-button': {
      minWidth: '120px',
      '&:not(:first-of-type)': {
        marginTop: '5px'
      }
    }
  }
}), "");
export { ActionButton, BannerContainer, DialogWrapper, IconWrapper };